<template>
  <div class="dev-grid">
    <article
      v-for="(d, i) in groups"
      :key="d.group"
      class="dev card reveal"
      v-reveal="{ delay: i * 90 }"
    >
      <span class="dev-badge">{{ d.group }}</span>
      <ul class="dev-list">
        <li v-for="(it, ii) in d.items" :key="ii">
          <IconSvg name="check"/>
          <span>{{ it }}</span>
        </li>
      </ul>
    </article>
  </div>
</template>

<script>
import IconSvg from './IconSvg'

export default {
  name: 'Deliverables',
  components: { IconSvg },
  props: {
    groups: { type: Array, default: () => [] }
  }
}
</script>

<style lang="scss" scoped>
.dev-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.dev {
  padding: 24px 22px;
}

.dev-badge {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--accent-txt);
  border: 1px solid color-mix(in srgb, var(--accent) 45%, transparent);
  background: color-mix(in srgb, var(--accent) 10%, transparent);
}

.dev-list {
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin-top: 18px;

  li {
    display: flex;
    gap: 9px;
    font-size: 13.5px;
    line-height: 1.7;
    color: var(--txt-2);
  }

  svg {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    margin-top: 5px;
    color: var(--accent-txt);
  }
}

@media (max-width: 1080px) {
  .dev-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 760px) {
  .dev-grid { grid-template-columns: minmax(0, 1fr); gap: 14px; }
}
</style>
